import React from 'react';

import { Col, Row } from 'reactstrap';
import { Image, P } from '../../../AbstractElements';
import { ThankYouMessage, ThankYouMessageDescription } from '../../../Constant';

import paypal from '../../../assets/images/other-images/paypal.png';

const ThankMessage = () => {
  return (
    <Row className='mt-3'>
      <Col md='8'>
        <div>
          <P className='legal'>
            <strong>{ThankYouMessage}</strong>&nbsp; {ThankYouMessageDescription}
          </P>
        </div>
      </Col>
      <Col md='4'>
        <div className='text-end invo-pal'>
          <Image className='ms-auto' src={paypal} alt='PayPal - The safer, easier way to pay online!' />
        </div>
      </Col>
    </Row>
  );
};

export default ThankMessage;
